import React from "react";

import { Heading2, Heading3, Heading4, Heading5, Heading6 } from "../../common";

interface Props {
  level: number;
  children: React.ReactNode;
}

export const MappedHeading: React.FC<Props> = ({ level, ...props }) => {
  switch (level) {
    case 2:
      return <Heading2 {...props} />;
    case 3:
      return <Heading3 {...props} />;
    case 4:
      return <Heading4 {...props} />;
    case 5:
      return <Heading5 {...props} />;
    default:
      return <Heading6 {...props} />;
  }
};
